<template>
    <div>
        <div class="row pt-3 result-item" v-for="(item, index) in resultItems" :key="'taskHistory'+index">
            <div>
                <h5>{{resultItems.length-index}}.</h5>
            </div>
            <div class="col-md-12 d-flex">
                <div class="font-weight-bold mr-3">{{$t('tasks.date')}}:</div>
                <div>{{$moment(new Date(item.createdOn)).format('DD.MM.YYYY HH:mm')}}</div>
            </div>
            <div class="col-md-12">
                <div class="d-flex">
                    <div class="font-weight-bold pr-3">{{$t('tasks.timeToFinish')}}:</div>
                    <div class="d-flex pr-1">
                        <span>{{item.hoursToFinish}}</span>&nbsp;
                        <span style="height: fit-content; align-self: center;">{{$t('hoursAbbr')}}</span>
                    </div>
                    <div class="d-flex">
                        <span>{{item.minutesToFinish}}</span>&nbsp;
                        <span style="height: fit-content; align-self: center;">{{$t('minutesAbbr')}}</span>
                    </div>
                </div>
            </div>
            <div class="col-md-12" v-if="item.answer">
                <div class="font-weight-bold">{{$t('coordinations.comment')}}:</div>
                <div>{{item.answer}}</div>
            </div>

            <hr />

            <div class="col-md-12" v-if="item.attachments">
                <div class="font-weight-bold">{{ item.attachments.length > 1 ? $t('tasks.attachments') : $t('tasks.attachment')}}:</div>
                <div class="mb-2" v-for="item in item.attachments" :key="_uid+item.fileName">
                    <file-crud :file="item"
                               :readonly="true"
                               :showDescription="false"
                               :editable="false"
                               :type="item.docTypeCode">
                    </file-crud>
                </div>
            </div>
        </div>
        <div v-if="!resultItems.length">
            <div class="alert alert-danger" role="alert">{{$t('tasks.noAnswerMessage')}}</div>
        </div>
    </div>
</template>

<script>
    import tasksService from '../../services/tasks.service';
    import FileCrud from '../common/FileCRUD';
    import { File } from '../../models/models';

    export default {
        components: {
            FileCrud
        },
        props: {
            taskId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                resultItems: []
            };
        },
        methods: {
            async loadData() {
                try {
                    var result = await tasksService.getTaskResult(this.taskId);
                    result.data.forEach(item => {
                        if (item.attachment) {
                            item.attachment = new File(item.attachment);
                        }
                    });
                    this.resultItems = result.data;
                } catch (err) {
                    this.$vs.notify({
                        color: 'danger',
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(err)
                    });
                }
            }
        },
        mounted() {
            this.loadData();
        }
    };
</script>

<style lang="scss" scoped>
    .result-item {
        border-bottom: 1px solid lightgrey;
    }
</style>
